import { useState } from "react";
import style from "./dropBox.module.scss";

export const DropBox = ({ side, photo, onRemove, handleDrop }) => {
  const [isDragOver, setIsDragOver] = useState(false);

  return (
    <div
      className={`border ${style.drop_box} ${isDragOver ? style.drag_over : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setIsDragOver(true);
      }}
      onDragLeave={() => setIsDragOver(false)}
      onDrop={(e) => {
        setIsDragOver(false);
        handleDrop(e, side);
      }}
    >
      {photo ? (
        <>
          <img src={photo.src} alt={photo.label} className="w-100 h-100" style={{ objectFit: "cover" }} />
          <button type="button" className={`btn btn-sm ${style.drop_box_btn}`} onClick={onRemove}>
            <i className="fa fa-times fa-sm" aria-hidden="true"></i>
          </button>
        </>
      ) : (
        <>
          <i className={`fa fa-image ${style.drop_icon}`} aria-hidden="true"></i>
          <span className={style.drop_text}>Drop {side} Photo</span>
        </>
      )}
    </div>
  );
};
